module.exports = __webpack_public_path__ + "img/periscope.2cd9a69d.svg";